<app-navbar></app-navbar>

<!-- Interrupts the user on whatever page they are on; renders nothing when idle. -->
<app-prospect-reminder-dialog />

<div class="flex flex-1 min-h-0 min-w-0">
  <aside
    class="sidebar flex shrink-0 flex-col overflow-hidden border-r border-[var(--app-border)]
      bg-[var(--app-surface)] transition-[width] duration-300 ease-in-out"
    [class.sidebar--expanded]="sidebarExpanded"
    (mouseenter)="sidebarExpanded = true"
    (mouseleave)="sidebarExpanded = false"
  >
    <div class="flex h-full w-56 shrink-0 flex-col">
      <div class="border-b border-[var(--app-border)] p-4">
        <span class="sidebar-label whitespace-nowrap text-lg font-semibold text-[var(--app-text)]">Menu</span>
      </div>
      <div class="sidebar-menu flex-1 overflow-y-auto p-2">
        <p-menu [model]="menuModel" styleClass="w-full border-none" />
      </div>
    </div>
  </aside>

  <div class="flex-1 min-w-0 min-h-0 flex flex-col overflow-y-auto min-h-0">
    <div class="protected-outlet flex-1 min-h-0 flex flex-col">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
